import React, { Suspense } from "react";
import { MemoryRouter as Router, Switch, Route } from "react-router-dom";
import { translation } from "helpers/utilsHelper.js";
import * as styled from "./StyledVirtual";

const COMPONENT_MAP = {
  vfb: React.lazy(() => import("./sports/Vfb")),
  vflm: React.lazy(() => import("./sports/Vflm")),
  vfec: React.lazy(() => import("./sports/Vfec")),
  vfwc: React.lazy(() => import("./sports/Vfwc")),
  vfel: React.lazy(() => import("./sports/Vfel")),
  vfsl: React.lazy(() => import("./sports/Vfsl")),
  vbl: React.lazy(() => import("./sports/Vbl")),
  vti: React.lazy(() => import("./sports/Vti")),
};

const URL_MAP = {
  vfb:  process.env.VIRTUALS_VFB_URL,
  vflm: process.env.VIRTUALS_VFLM_URL,
  vfec: process.env.VIRTUALS_VFEC_URL,
  vfwc: process.env.VIRTUALS_VFWC_URL,
  vfel: process.env.VIRTUALS_VFEL_URL,
  vfsl: process.env.VIRTUALS_VFSL_URL,
  vbl:  process.env.VIRTUALS_VBL_URL,
  vti:  process.env.VIRTUALS_VTI_URL,
};

const getSportComponent = (sport) => {
  if (!sport) return null;
  return COMPONENT_MAP[sport.toLowerCase()] || null;
};

const Virtual = () => {

  const sports = process.env.VIRTUAL_SPORTS
    ? process.env.VIRTUAL_SPORTS.split(",")
        .map((s) => s.trim().toLowerCase())
        .filter(s => (URL_MAP[s] || '').length > 1)
    : [];

  return (
    <Router>
      <>
        <styled.Nav>
          <styled.NavList>
            {sports.map((sport, index) => (
              <styled.NavItem key={`${sport}_${index}`}>
                <styled.NavLink exact={index === 0} to={index === 0 ? "/" : `/${sport}`}>
                  {translation(`virtuals_sport_${sport.toUpperCase()}`)}
                </styled.NavLink>
              </styled.NavItem>
            ))}
          </styled.NavList>
        </styled.Nav>
        <Suspense fallback={<div>Ładowanie...</div>}>
          <Switch>
            {sports.map((sport, index) => {
              const Comp = getSportComponent(sport);
              const path = index === 0 ? "/" : `/${sport}`;
              if (!Comp) {
                return (
                  <Route
                    key={sport}
                    exact={index === 0}
                    path={path}
                    render={() => <div>{translation(`virtuals_sport_${sport.toUpperCase()}`)} Unavailable</div>}
                  />
                );
              }

              return <Route key={sport} exact={index === 0} path={path} component={Comp} />;
            })}
          </Switch>
        </Suspense>
      </>
    </Router>
  );
};

export default Virtual;
